import { Location } from "@angular/common";
import { HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import {
    ActivatedRouteSnapshot,
    Resolve,
    RouterStateSnapshot,
} from "@angular/router";
import { ApiGateway, PageOptions, SendingToFinance } from "cw-backend";
import { CwUtils } from "cw-utils";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable()
export class SendingToFinanceListProvider implements Resolve<any> {
    sendingToFinance: SendingToFinance[];
    sendingToFinanceEdit: SendingToFinance;
    onDataChanged: BehaviorSubject<any>;
    routeParams: any;
    state: any;
    pageOptions: PageOptions;
    currentPage: PageOptions;

    constructor(public gw: ApiGateway, private location: Location) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        // Get state for current or new page
        this.state = this.location.getState();
        this.currentPage = this.state?.currentPage;
        this.sendingToFinanceEdit = this.state?.currentSendingToFinance;

        if (this.currentPage) {
            this.pageOptions = this.currentPage;
        } else {
            this.pageOptions = new PageOptions();
            this.pageOptions.fieldSort = "dated";
        }
        return new Promise((resolve, reject) => {
            Promise.all([this.getPage(this.pageOptions)]).then(() => {
                resolve(true);
            }, reject);
        });
    }

    get(id: number): Observable<SendingToFinance> {
        if (!id) {
            return null;
        }
        return this.gw.get("sendingToFinance/:id", { id: id });
    }

    get currentSendingToFinance(): SendingToFinance {
        return this.sendingToFinanceEdit;
    }

    getAll(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.get("sendingToFinance/").subscribe({
                next: (res: HttpResponse<any>) => {
                    this.sendingToFinance = res.body;
                    resolve(res);
                },
                error: (err: any) => {
                    reject(err);
                },
            });
        });
    }

    getPage(pageOptions: PageOptions): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post("sendingToFinance/search", pageOptions).subscribe({
                next: (res: HttpResponse<any>) => {
                    if (
                        !CwUtils.compare(
                            this.sendingToFinance,
                            res.body.content
                        ) &&
                        res.body.content.length > 0
                    ) {
                        this.sendingToFinance = res.body.content;
                        this.onDataChanged.next(this.sendingToFinance);
                    } else {
                        this.sendingToFinance = res.body.content;
                    }
                    resolve(res);
                },
                error: (err: any) => {
                    reject(err);
                },
            });
        });
    }

    getPageProcess(filterTo: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .post("sendingToFinance/search/process", filterTo)
                .subscribe({
                    next: (res: HttpResponse<any>) => {
                        resolve(res);
                    },
                    error: (err: any) => {
                        reject(err);
                    },
                });
        });
    }

    getPageItens(id: any, pageOptions: PageOptions): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .post(`sendingToFinance/search/process/${id}`, pageOptions)
                .subscribe({
                    next: (res: HttpResponse<any>) => {
                        resolve(res);
                    },
                    error: (err: any) => {
                        reject(err);
                    },
                });
        });
    }

    getSendingToFinanceFilter(id): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.get(`sendingToFinance/${id}/sending-to-finance/list`).subscribe({
                next: (res: HttpResponse<any>) => {
                    resolve(res);
                }, error: (err: any) => { reject(err) }
            });
        });
    }

    getPageSettings() {
        if (this.currentPage) {
            return this.pageOptions;
        } else {
            return;
        }
    }
}
